import React from 'react';
import { useSelector } from 'react-redux';
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Button,
    IconButton,
    CircularProgress
} from '@mui/material';
import { Check, Delete, Edit } from '@mui/icons-material';
import EditBankDetail from './EditBankDetail';
import useAddedBankList from '../hooks/useAddedBankList';
import { H6, Body2, Body1 } from '../../../../../themes/typography';
import '../../../../../styles/components/Invitation.css';

function AddedBankList() {
    const bankList = useSelector((state) => state.bank.bankDetails?.data || []);
    const { openEditModal } = useSelector((state) => state.bank);

    const {
        deleteBankDetail,
        deletingId,
        handleEdit,
        editLoadingId,
        closeEditModal,
        handleMarkAsPrimary
    } =
        useAddedBankList();

    return (
        <React.Fragment>
            {openEditModal && <EditBankDetail onClose={closeEditModal} />}
            <div className="invitation-list-container" style={{ width: '100%' }}>
                <TableContainer sx={tableContainerStyle}>
                    <Table stickyHeader aria-label="sticky table">
                        <TableHead sx={dataCellStyle}>
                            <TableRow sx={dataCellStyle}>
                                <TableCell align="left" sx={headerCellStyle}>
                                    <H6>Bank Name</H6>
                                </TableCell>
                                <TableCell align="center" sx={headerCellStyle}>
                                    <H6>Account Number</H6>
                                </TableCell>
                                <TableCell align="center" sx={headerCellStyle}>
                                    <H6>Nick Name</H6>
                                </TableCell>
                                <TableCell align="center" sx={headerCellStyle}>
                                    <H6>Account Type</H6>
                                </TableCell>
                                <TableCell align="center" sx={headerCellStyle}>
                                    <H6>Edit</H6>
                                </TableCell>
                                <TableCell align="center" sx={headerCellStyle}>
                                    <H6>Delete</H6>
                                </TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {bankList?.map((row) => (
                                <TableRow
                                    hover
                                    role="checkbox"
                                    tabIndex={-1}
                                    key={row?.id}
                                    sx={{
                                        borderBottom: '1px solid rgba(153, 166, 173, 0.35)'
                                    }}
                                >
                                    <TableCell align="left" sx={dataCellStyle}>
                                        <div style={attendeeDetail}>
                                            <Body1>{row.bank_name}</Body1>
                                        </div>
                                    </TableCell>
                                    <TableCell align="center" sx={dataCellStyle}>
                                        <Body2>{row.account_number}</Body2>
                                    </TableCell>
                                    <TableCell align="center" sx={dataCellStyle}>
                                        <Body2>{row.nickname}</Body2>
                                    </TableCell>
                                    <TableCell align="center" sx={dataCellStyle}>
                                        <Body2>
                                            {row.is_primary ? (
                                                <Button
                                                    variant="success"
                                                    endIcon={<Check />}
                                                >
                                                    Primary
                                                </Button>
                                            ) : (
                                                <Button
                                                    variant="warning"
                                                    onClick={() => handleMarkAsPrimary(row?.id)}
                                                >
                                                    Secondary
                                                </Button>
                                            )}
                                        </Body2>
                                    </TableCell>
                                    <TableCell align="center" sx={dataCellStyle}>
                                        <IconButton
                                            color="secondary"
                                            disabled={editLoadingId === row?.id}
                                            onClick={() => handleEdit(row?.id)}
                                        >
                                            {editLoadingId === row?.id ? (
                                                <CircularProgress
                                                    size={24}
                                                    sx={{ color: 'var(--quaternary-color)' }}
                                                />
                                            ) : (
                                                <Edit />
                                            )}
                                        </IconButton>
                                    </TableCell>
                                    <TableCell align="center" sx={dataCellStyle}>
                                        <IconButton
                                            color="danger"
                                            onClick={() => deleteBankDetail(row?.id)}
                                            disabled={deletingId === row.id}
                                        >
                                            {deletingId === row.id ? (
                                                <CircularProgress
                                                    size={24}
                                                    sx={{ color: 'var(--quaternary-color)' }}
                                                />
                                            ) : (
                                                <Delete />
                                            )}
                                        </IconButton>
                                    </TableCell>
                                </TableRow>
                            ))}
                            {bankList.length === 0 && (
                                <TableRow>
                                    <TableCell colSpan={6} align="center">
                                        <Body1>No bank accounts found</Body1>
                                    </TableCell>
                                </TableRow>
                            )}
                        </TableBody>
                    </Table>
                </TableContainer>
            </div>
        </React.Fragment>
    );
}

export default AddedBankList;

const attendeeDetail = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: '0.25rem'
};

const tableContainerStyle = {
    borderTopRightRadius: '1rem',
    borderTopLeftRadius: '1rem',
    maxHeight: '70vh'
};

const headerCellStyle = {
    backgroundColor: '#283853',
    borderBottom: 'none'
};

const dataCellStyle = {
    borderBottom: '1px solid rgba(153, 166, 173, 0.35)'
};
